const debounce = (callback, waitMS) => {
    let timeoutId = null;
    const debounced = function (...args) {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            callback?.apply(this, args);
        }, waitMS);
    };
    debounced.cancel = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    return debounced;
};

export { debounce };
//# sourceMappingURL=debounce.js.map
